import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { hasVisibleContent } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const documentContentStatePluginKey = new PluginKey('ai-document-content-state');

export type DocumentContentState = {
	hasVisibleContent: boolean;
};

export const createDocumentContentStatePlugin = () => {
	return new SafePlugin<DocumentContentState>({
		key: documentContentStatePluginKey,
		state: {
			init(_, state) {
				return {
					hasVisibleContent: hasVisibleContent(state.doc),
				};
			},
			apply(tr, pluginState, _, newState) {
				if (!tr.docChanged) {
					return pluginState;
				}

				const newHasVisibleContent = hasVisibleContent(newState.doc);

				if (pluginState.hasVisibleContent !== newHasVisibleContent) {
					return {
						hasVisibleContent: newHasVisibleContent,
					};
				}

				return pluginState;
			},
		},
	});
};
